module.exports = require("@vscode-alt/monaco-editor/esm/vs/nls");